var _defs, _rect, _ellipse, _path, _circle, _circle2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 240,
    viewBox: "0 0 400 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: 36,
    y1: 18,
    x2: 364,
    y2: 222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A4F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E2D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pinGradient",
    x1: 200,
    y1: 70,
    x2: 200,
    y2: 190,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF0F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "haloGradient",
    x1: 120,
    y1: 194,
    x2: 280,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 240,
    rx: 12,
    fill: "url(#bgGradient)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 194,
    rx: 90,
    ry: 18,
    fill: "url(#haloGradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 64C165.4 64 137.5 91.8 137.5 126.5C137.5 145.5 146.7 163 162 175.8L198.8 207.8C199.5 208.4 200.5 208.4 201.2 207.8L238 175.8C253.3 163 262.5 145.5 262.5 126.5C262.5 91.8 234.6 64 200 64Z",
    fill: "url(#pinGradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 126,
    r: 26,
    fill: "#2A4F8E",
    fillOpacity: 0.92
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 126,
    r: 12,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162 175.8L198.8 207.8C199.5 208.4 200.5 208.4 201.2 207.8L238 175.8C242.4 172.2 246.3 168.1 249.7 163.7C236.8 170.1 219.2 174 200 174C180.8 174 163.2 170.1 150.3 163.7C153.7 168.1 157.6 172.2 162 175.8Z",
    fill: "#D4DEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPlaceholder);
export default __webpack_public_path__ + "static/media/LocationPlaceholder.8b47919bdd3a6bd5c4cc498045543fa5.svg";
export { ForwardRef as ReactComponent };